import React from 'react';
import PropTypes from 'prop-types';
import Tags from './Tags';

const getTags = (keywords) => {
	let tags = [];

	keywords.forEach((keyword) => {
		tags.push({
			id: `kw-${keyword}`,
			name: keyword,
			url: `/search/${encodeURIComponent(keyword)}`,
		});
	});

	return tags;
};

const getCategories = (categories) => {
	let cats = [];

	categories.forEach(({ id, shortName, slug }) => {
		cats.push({
			id: `category-${id}`,
			name: shortName,
			url: `/category/${slug}/`,
		});
	});

	return cats;
};

const TagsContainer = ({ categories, keywords }) =>
	<Tags
		tags={getTags(keywords)}
		categories={getCategories(categories)}
	/>;

TagsContainer.propTypes = {
	keywords: PropTypes.array,
	categories: PropTypes.array.isRequired,
};

TagsContainer.defaultProps = {
	keywords: [],
};

export default TagsContainer;
